import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { Select } from 'components/project/ClerkScreen';
import {
  getStoredAuctionIdByPath,
  getStoredAuctionLaneIdByPath,
} from 'shared/utils/localStorage';

import {
  ItemSearch,
  ItemListContainer,
  SectionTitle,
  AuctionAndLaneContainer,
} from './Styles';

const Settings = observer(({
  auctionList, handleAuctionChange, handleLaneChange, totalClerksInLane,
}) => {
  const {
    UIStore: { handleJoinAuction },
    AuctionStore: { laneList },
  } = useStores();

  const [doJoinAuction, setDoJoinAuction] = useState(true);

  const handleLocalLaneChange = (e) => {
    handleLaneChange(e);
  };

  useEffect(() => {
    if (
      doJoinAuction
      && getStoredAuctionLaneIdByPath() !== ''
      && laneList
      && laneList.length === 0
    ) {
      handleJoinAuction(getStoredAuctionIdByPath());
    }
    return () => {
      setDoJoinAuction(false);
    };
  }, [doJoinAuction, laneList, laneList.length, handleJoinAuction]);

  return (
    <ItemSearch>
      <>
        <SectionTitle>Settings</SectionTitle>
        <ItemListContainer>
          <AuctionAndLaneContainer>
            {auctionList && auctionList.length > 0 && (
              <Select
                valueProp="auctionID"
                textProp="auction"
                currentValue={getStoredAuctionIdByPath()}
                data={auctionList}
                noneSelectedText="-- Choose Auction --"
                onChange={handleAuctionChange}
              />
            )}

            {getStoredAuctionLaneIdByPath() !== '' && (
              <Select
                valueProp="laneID"
                textProp="lane"
                currentValue={getStoredAuctionLaneIdByPath()}
                data={laneList}
                noneSelectedText="-- Choose Lane --"
                onChange={handleLocalLaneChange}
              />
            )}
          </AuctionAndLaneContainer>
          <div>
            Connected Clerk Screens:
            <span style={{ paddingLeft: '10px' }}>{totalClerksInLane || 1}</span>
          </div>
        </ItemListContainer>
      </>
    </ItemSearch>
  );
});

Settings.propTypes = {
  auctionList: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  handleAuctionChange: PropTypes.func.isRequired,
  handleLaneChange: PropTypes.func.isRequired,
  totalClerksInLane: PropTypes.number,
};

Settings.defaultProps = {
  totalClerksInLane: 1,
};

export default Settings;
